import { isIE } from '../../utils/isIE';
import { internalLogger } from '../../interface/v1/clientOsLogger';

const boostrappingBrowser = () => {
  if (isIE()) {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'Initializer',
      methodName: 'boostrappingBrowser()',
      message: 'Running in IE11 - applying polyfill workarounds'
    });
    // I regret to code it. Unfortunately, this is a awful fix for the IE11
    // Proxy-Pollyfill bug.
    Object.preventExtensions = <T>(o: T) => {
      /* istanbul ignore next */
      internalLogger?.debug?.d5?.({
        className: 'Initializer',
        methodName: 'boostrappingBrowser()',
        message: 'Removing preventExtensions due to IE11 Proxy polyfill bug'
      });
      return o;
    };
    Object.seal = <T>(o: T) => {
      /* istanbul ignore next */
      internalLogger?.debug?.d5?.({
        className: 'Initializer',
        methodName: 'boostrappingBrowser()',
        message: 'Removing seal due to IE11 Proxy polyfill bug'
      });
      return o;
    };
  }
};

boostrappingBrowser();
